<script setup>
import { onMounted, ref, watchEffect } from 'vue';
import { useUserStore } from '@/stores/user';

const userStore = useUserStore();
const IDLE_TIME = 15 * 60 * 1000; // ms
const RESET_TIME = 1000; // ms
const userActivityThrottlerTimeout = ref(null);
const userActivityTimeout = ref(null);

watchEffect(() => {
  if (userStore.increaseLoginTime) {
    clearTimeout(userActivityTimeout.value);
    clearTimeout(userActivityThrottlerTimeout);
    return;
  }
  resetUserActivityTimeout();
});

function resetUserActivityTimeout() {
  clearTimeout(userActivityTimeout.value);
  userActivityTimeout.value = setTimeout(inactiveUserAction, IDLE_TIME);
}

function activateActivityTracker() {
  window.addEventListener('mousemove', userActivityThrottler);
  window.addEventListener('scroll', userActivityThrottler);
  window.addEventListener('keydown', userActivityThrottler);
  window.addEventListener('resize', userActivityThrottler);
}

function userActivityThrottler() {
  if (userActivityThrottlerTimeout.value) return;

  userActivityThrottlerTimeout.value = setTimeout(() => {
    resetUserActivityTimeout();
    clearTimeout(userActivityThrottlerTimeout);
    userActivityThrottlerTimeout.value = null;
  }, RESET_TIME);
}

async function inactiveUserAction() {
  await userStore.logout();
}

onMounted(activateActivityTracker);
</script>
